<template>
  <modal
    :isModalStatic="true"
    :isHideHeaderCloseButton="true"
    :isHideFooter="true"
    componentName="RegisterModal"
    bodyCssClasses="plump">
    <template v-slot:body>
      <component
        :is="dynamicComponent"
        ref="registerModal"
        :mobile-phone="mobilePhone"
        @cancel="closeModal('RegisterModal')"
        @invoke-confirm-order="$emit('invoke-confirm-order')" />
    </template>
  </modal>
</template>

<script>
import { closeModal } from '@/helpers/modal';
import { getState } from '@/helpers/vuex';
import Modal from '@/components/common/common-modal.vue';
import Step1 from '@/components/mobile/step2/payment-type/register-into-modal/step1.vue';
import Step2 from '@/components/mobile/step2/payment-type/register-into-modal/step2.vue';

export default {
  name: 'registerInfoModal',
  inject: ['$validator'],
  props: {
    mobilePhone: {
      type: String,
      default: '',
    },
  },
  components: {
    Modal,
    Step1,
    Step2,
  },
  methods: {
    closeModal,
  },
  computed: {
    dynamicComponent: getState('DynamicComponents', 'registerMethod'),
  },
};
</script>
